// import React from "react";
// import { Box, Typography, TextField, Grid, Paper, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// function ReadOnlyField({ label, value }) {
//   // Show empty string or file name for File objects
//   let displayValue = "";
//   if (value instanceof File) {
//     displayValue = value.name;
//   } else if (value === null || value === undefined) {
//     displayValue = "";
//   } else if (typeof value === "object" && !Array.isArray(value)) {
//     displayValue = JSON.stringify(value);
//   } else {
//     displayValue = value.toString();
//   }

//   return (
//     <TextField
//       label={label.replaceAll("_", " ")}
//       value={displayValue}
//       fullWidth
//       margin="dense"
//       InputProps={{ readOnly: true }}
//       variant="outlined"
//     />
//   );
// }

// export default function ClaimPreview({ data }) {
//   if (!data) return null;

//   // Render a section of simple key-value pairs as read-only inputs
//   const renderSection = (title, obj) => (
//     <Box sx={{ my: 2 }}>
//       <Typography variant="h6" gutterBottom>{title}</Typography>
//       <Paper variant="outlined" sx={{ p: 2, bgcolor: "#fafafa" }}>
//         <Grid container spacing={2}>
//           {Object.entries(obj).length === 0 ? (
//             <Typography color="text.secondary">No data</Typography>
//           ) : (
//             Object.entries(obj).map(([key, value]) => (
//               <Grid item xs={12} sm={6} key={key}>
//                 <ReadOnlyField label={key} value={value} />
//               </Grid>
//             ))
//           )}
//         </Grid> 
//       </Paper>
//     </Box>
//   );

//   // Render arrays (investments, loans, returned) as accordions with read-only fields
//   const renderArraySection = (title, arr) => (
//     <Box sx={{ my: 2 }}>
//       <Typography variant="h6" gutterBottom>{title}</Typography>
//       {arr.length === 0 ? (
//         <Typography color="text.secondary">No {title.toLowerCase()}</Typography>
//       ) : (
//         arr.map((item, idx) => (
//           <Accordion key={idx} defaultExpanded={false} sx={{ mb: 1 }}>
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Typography variant="subtitle1">{`${title} ${idx + 1}`}</Typography>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 {Object.entries(item).map(([key, value]) => (
//                   <Grid item xs={12} sm={6} key={key}>
//                     <ReadOnlyField label={key} value={value} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         ))
//       )}
//     </Box>
//   );

//   return (
//     <Box sx={{ maxHeight: 520, overflowY: "auto", p: 1 }}>
//       {renderSection("Base Information", data.base)}
//       {renderSection("Adhaar Ekyc Details", data.base.txn_no ? { txn_no: data.base.txn_no } : {})}
//       {renderSection("Affidavit", data.affidavit)}
//       {renderSection("Customer Details", data.cust)}
//       {renderSection("Nominee", data.nominee)}
//       {renderSection("Legal Heir", data.legalHeir)}

//       {renderArraySection("Investments", data.investments || [])}

//       {renderArraySection("Deposited Details", data.depositedBanks || [])}
//       {renderArraySection("Loans", data.loans || [])}
//       {renderArraySection("Returned", data.returneds || [])}

//       {renderSection("Refund Bank Details", data.refundBank)}
//       {renderSection("Totals", data.total)}
//     </Box>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Chip,
  Avatar,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VerifiedIcon from "@mui/icons-material/Verified";
import api from "../../api/axiosInterceptor";

function ReadOnlyField({ label, value }) {
  let displayValue = "";

  if (value instanceof File) {
    displayValue = value.name;
  } else if (value === null || value === undefined) {
    displayValue = "";
  } else if (typeof value === "object" && !Array.isArray(value)) {
    displayValue = JSON.stringify(value);
  } else {
    displayValue = value.toString();
  }

  return (
    <TextField
      label={label.replaceAll("_", " ")}
      value={displayValue}
      fullWidth
      margin="dense"
      InputProps={{ readOnly: true }}
      variant="outlined"
    />
  );
}

export default function ClaimPreview({ data }) {
  const [ekycData, setEkycData] = useState(null);
  const [ekycLoading, setEkycLoading] = useState(false);

  useEffect(() => {
    const fetchEkyc = async () => {
      if (!data?.base?.txn_no) return;

      try {
        setEkycLoading(true);

        const response = await api.get(
          `/auth/aadhaar-data/?txnno=${data.base.txn_no}`
        );

        setEkycData(response?.data?.data || response?.data);
      } catch (err) {
        console.error("EKYC Fetch Error:", err);
      } finally {
        setEkycLoading(false);
      }
    };

    fetchEkyc();
  }, [data?.base?.txn_no]);

  if (!data) return null;

  // Simple Section
  const renderSection = (title, obj) => (
    <Box sx={{ my: 2 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, bgcolor: "#fafafa" }}>
        <Grid container spacing={2}>
          {Object.entries(obj).length === 0 ? (
            <Typography color="text.secondary">No data</Typography>
          ) : (
            Object.entries(obj).map(([key, value]) => (
              <Grid item xs={12} sm={6} key={key}>
                <ReadOnlyField label={key} value={value} />
              </Grid>
            ))
          )}
        </Grid>
      </Paper>
    </Box>
  );

  // Array Section
  const renderArraySection = (title, arr) => (
    <Box sx={{ my: 2 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>

      {arr.length === 0 ? (
        <Typography color="text.secondary">
          No {title.toLowerCase()}
        </Typography>
      ) : (
        arr.map((item, idx) => (
          <Accordion key={idx} defaultExpanded={false} sx={{ mb: 1 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                {`${title} ${idx + 1}`}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2}>
                {Object.entries(item).map(([key, value]) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <ReadOnlyField label={key} value={value} />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))
      )}
    </Box>
  );

  // Aadhaar Section
  const renderAadhaarSection = () => {
    const ekyc = ekycData?.ekyc_data || {};

    const fullAddress = [
      ekyc.house,
      ekyc.street,
      ekyc.loc,
      ekyc.vtc,
      ekyc.dist,
      ekyc.state,
      ekyc.pc,
      ekyc.country,
    ]
      .filter(Boolean)
      .join(", ");

    return (
      <Box sx={{ my: 2 }}>
        <Typography variant="h6" gutterBottom>
          Aadhaar E-KYC Details
        </Typography>

        {ekycLoading ? (
          <Paper
            variant="outlined"
            sx={{
              p: 4,
              textAlign: "center",
              bgcolor: "#fafafa",
            }}
          >
            <CircularProgress />
            <Typography mt={2}>
              Loading Aadhaar Verification...
            </Typography>
          </Paper>
        ) : !ekycData ? (
          <Paper
            variant="outlined"
            sx={{
              p: 3,
              textAlign: "center",
              bgcolor: "#fafafa",
              borderRadius: 3,
            }}
          >
            <Typography fontWeight={600} color="text.secondary">
              Verified using Different Method
            </Typography>
          </Paper>
        ) : (
          <Paper
            variant="outlined"
            sx={{
              p: 3,
              borderRadius: 3,
              bgcolor: "#fafafa",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                mb: 3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <VerifiedIcon color="success" />

                <Typography fontWeight={700}>
                  Aadhaar Verified Successfully
                </Typography>
              </Box>

              <Chip
                label={`Name Match: ${
                  ekycData?.name_matching_percentage || 0
                }%`}
                color={
                  Number(ekycData?.name_matching_percentage) >= 80
                    ? "success"
                    : "warning"
                }
                sx={{ fontWeight: 700 }}
              />
            </Box>

            <Grid container spacing={3}>
              {/* Photo */}
              <Grid item xs={12} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {ekycData?.Photo ? (
                    <Avatar
                      variant="rounded"
                      src={`data:image/jpeg;base64,${ekycData.Photo}`}
                      sx={{
                        width: 180,
                        height: 220,
                        borderRadius: 3,
                        border: "1px solid #ddd",
                      }}
                    />
                  ) : (
                    <Paper
                      variant="outlined"
                      sx={{
                        width: 180,
                        height: 220,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      No Photo
                    </Paper>
                  )}
                </Box>
              </Grid>

              {/* Details */}
              <Grid item xs={12} md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <ReadOnlyField
                      label="Full Name"
                      value={ekyc.name}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <ReadOnlyField
                      label="Date of Birth"
                      value={ekyc.dob}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <ReadOnlyField
                      label="Father / Guardian Name"
                      value={ekyc.co}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <ReadOnlyField
                      label="Masked Aadhaar"
                      value={ekycData.maskedAadhaar}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <ReadOnlyField
                      label="Gender"
                      value={ekyc.gender}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <ReadOnlyField
                      label="Verification Status"
                      value={ekycData.status}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ReadOnlyField
                      label="Address"
                      value={fullAddress}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        )}
      </Box>
    );
  };

  return (
    <Box sx={{ maxHeight: 520, overflowY: "auto", p: 1 }}>
      {renderSection("Base Information", data.base)}

      {renderAadhaarSection()}

      {renderSection("Affidavit", data.affidavit)}
      {renderSection("Customer Details", data.cust)}
      {renderSection("Nominee", data.nominee)}
      {renderSection("Legal Heir", data.legalHeir)}

      {renderArraySection("Investments", data.investments || [])}

      {renderArraySection(
        "Deposited Details",
        data.depositedBanks || []
      )}

      {renderArraySection("Loans", data.loans || [])}

      {renderArraySection("Returned", data.returneds || [])}

      {renderSection(
        "Refund Bank Details",
        data.refundBank
      )}

      {renderSection("Totals", data.total)}
    </Box>
  );
}